export default {
  SET_BUSINESSES(state, businesses) {
    state.businesses = businesses
  },
  SET_BUSINESSES_COUNT(state, count) {
    state.businessesCount = count
  },
  SET_BUSINESSES_QUERY(state, query) {
    state.query = query
  },
  SET_BUSINESSES_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_BUSINESSES_SKIP(state, skip) {
    state.skip = skip
  },
  SET_BUSINESSES_SORT(state, sort) {
    state.sort = sort
  }
}
